@if (component) {
<div [style.display]="'grid'"
     [gridColumnGap]="component.gap"
     [grid]="gridSize">
    @for (column of columns; track $index) {
    <icms-outlet [name]="'Column'"
                 [components]="column.components"
                 class="inline-block va-t"
                 [fullHeight]="true"
                 [gridColumn]="column.size">
    </icms-outlet>
    }
</div>
}